export default "__VITE_ASSET__lt9gf8SF__"